<mat-expansion-panel
  class="w-100 mat-elevation-z3 bdg-expansion-panel"
  [disabled]="disabled"
  [expanded]="expanded"
  [togglePosition]="toggleIconPosition"
  (opened)="handleToggle(true)"
  (closed)="handleToggle(false)"
  [hideToggle]="fixed"
>
  <mat-expansion-panel-header [collapsedHeight]="headerHeight" [style]="getStyle()">
    <mat-panel-title class="align-items-center">
      <span>{{ headerTitle }}</span>

      <mat-chip-list class="ml-3" style="font-weight: 400; font-size: 14px">
        <ng-content select="[headerTags]"></ng-content>
      </mat-chip-list>
    </mat-panel-title>
    <mat-panel-description class="align-items-center">
      <span *ngIf="!loading" class="ml-auto" style="font-style: italic; font-weight: 400">{{ headerSubtitle }}</span>
      <mat-spinner *ngIf="loading" class="ml-auto" diameter="20"></mat-spinner>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <ng-content></ng-content>
  </ng-template>
</mat-expansion-panel>
